import { Segmented as AntSegment } from "antd";
import "./style.scss";

function Segmented({
  options,
  state,
  setState = () => {},
  className = "",
  onChange = () => {},
}) {
  return (
    <AntSegment
      className={className}
      options={options}
      value={state}
      onChange={(value) => {
        setState(value);
        onChange(value);
      }}
    />
  );
}

export default Segmented;
